import * as Sentry from "@sentry/browser";
import { RefetchOptions, useQuery } from "react-query";
import * as Redux from "react-redux";

import * as UserService from "client/services/user";
import { errorActions } from "client/store";
import { RestoreResponse } from "client/types";

import { useMerchantModel } from "./useMerchantModel";

type UseRestore = {
  refetchRestore: (options?: RefetchOptions | undefined) => Promise<any>;
  userRestored: boolean;
};

export const useRestore = (shouldFetchRestore = true): UseRestore => {
  const { setMerchant } = useMerchantModel();

  const dispatch = Redux.useDispatch();

  const { isSuccess: userRestored, refetch: refetchRestore } = useQuery<
    RestoreResponse,
    Error
  >("user-state-onboarding", UserService.restoreUser, {
    enabled: Boolean(shouldFetchRestore),
    onSuccess: (restoreResponse) => {
      if (restoreResponse) {
        setMerchant(restoreResponse);
      }
    },
    onError(err) {
      dispatch(errorActions.setError(err.message));
      Sentry.captureException(`Error restoring user: ${err.message}`);
    },
  });

  return { refetchRestore, userRestored };
};
